module.exports = __webpack_public_path__ + "static/media/Interaction2.5b53c781.svg";